module.exports = __webpack_public_path__ + "assets/img/house_keep_service.a46529bc.png";